export const apiRequest = (apiType: string): string => `${apiType}_REQUEST`;
export const apiSuccess = (apiType: string): string => `${apiType}_SUCCESS`;
export const apiError = (apiType: string): string => `${apiType}_ERROR`;
